var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.intro-level-1{\n  font-size: .9rem;\n}\n\n.intro-level-1 h1{\n  font-size: 2rem;\n}\n\n.image1 {\n  background-image: url(" + escape(require("../Home/imm1.jpg")) + ");\n  background-color: #ffffff;\n  background-size: cover;\n  /*opacity: 0.5;*/\n}", ""]);

// exports
